import React from "react"
import { Box } from "@mui/material"
import { useTranslation } from "react-i18next"
import { BigNumber, FixedNumber } from "ethers"
import { BIG_ZERO } from "src/constants/bigNumber"
import { Cell, Pie, PieChart } from "recharts"
import Text from "src/components/Text"
import boostPools from "src/constants/boostPools"
import { formatLockPeriod } from "src/pages/Stake/helpers"
import { formatNumber, getRawAmount } from "src/utils/parseStringToBigNumber"
import { useIsMobile } from "src/hooks/useIsMobile"

const COLORS = ["#E9540E", "#009BE0", "#FFFFFF", "#F4A986"]

interface Props {
  data: {
    pid: string
    value: BigNumber
  }[]
}

const PieChartSection = ({ data }: Props) => {
  const { t } = useTranslation()
  const isMobile = useIsMobile()

  const total = data.map((x) => x.value).reduce((a, b) => a.add(b), BIG_ZERO)
  const formattedData = data.map((x) => ({
    value: getRawAmount(x.value).toUnsafeFloat(),
  }))

  return (
    <Box
      justifyContent="space-between"
      display="flex"
      mt={3}
      alignItems={isMobile ? "flex-end" : "flex-start"}
    >
      <Box>
        <Text mb={2}>{t("Allocation")}:</Text>
        <Box>
          {data.map((d, i) => (
            <Box alignItems="center" key={d.pid} display="flex" mt={1}>
              <Box
                width={10}
                height={10}
                borderRadius="50%"
                display="inline-block"
                bgcolor={COLORS[i % COLORS.length]}
                mr={1}
              />
              <Text>
                {formatLockPeriod(
                  boostPools.find((p) => p.pid === parseInt(d.pid))
                    ?.lockPeriod || 0,
                )}
              </Text>
              <Text ml={1}>
                {formatNumber(
                  FixedNumber.from(d.value)
                    .divUnsafe(FixedNumber.from(total))
                    .mulUnsafe(FixedNumber.from("100")),
                  2,
                  2,
                )}
                %
              </Text>
            </Box>
          ))}
        </Box>
      </Box>
      <Box>
        <PieChart width={isMobile ? 80 : 160} height={isMobile ? 80 : 160}>
          <Pie
            data={formattedData}
            cx="50%"
            cy="50%"
            labelLine={false}
            outerRadius={isMobile ? 40 : 80}
            fill="#8884d8"
            dataKey="value"
          >
            {data.map((entry, index) => (
              <Cell
                key={`cell-${entry.pid}`}
                fill={COLORS[index % COLORS.length]}
              />
            ))}
          </Pie>
        </PieChart>
      </Box>
    </Box>
  )
}

export default PieChartSection
